import { render, staticRenderFns } from "./SafetyHseMonitoring.vue?vue&type=template&id=4152f2e5&scoped=true"
import script from "./SafetyHseMonitoring.vue?vue&type=script&lang=js"
export * from "./SafetyHseMonitoring.vue?vue&type=script&lang=js"
import style0 from "./SafetyHseMonitoring.vue?vue&type=style&index=0&id=4152f2e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4152f2e5",
  null
  
)

export default component.exports